/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {
  AddToCart,
  // AddToFav,
  // OutOfStock,
  // FreeCustomize,
  // Message,
  Soldout,
  SubOptionLv1Section,
  SubOptionLv2Section,
  SubOptionLv3Section,
  Suggestions
} from "./RightContent";
import { connect } from "react-redux";
import { pdt } from "hf-rt";
import product_icon_30day from "../../../images/eshop/30arrow.png";
import product_icon_1year from "../../../images/eshop/icon-1year-maintenance.svg";
import { Translation } from "react-i18next";
import Matching from "../../OptionSelect/Matching";
import Sizes from "../../OptionSelect/Sizes";
import Material from "../../OptionSelect/Material";
import isArray from "../../../function/isArray";
import getCookie from "../../../function/getCookie";
import { pickUpInStore } from "../../../models";
import { setGAEvent } from "../../../function/setGAEvent";

let $ = window.$;
let style = {
  currencyPrice: { fontSize: "11px" }
};

class Right extends React.Component {
  state = {
    stickyY: 0,
    qtys: {}
  };
  componentDidMount() {
    const width = document.body.offsetWidth;
    // 監聽滾動事件
    if (width > 767) {
      window.addEventListener("scroll", this.handleSticky);
    }
  }

  componentWillUnmount() {
    // 移除監聽滾動事件
    window.removeEventListener("scroll", this.handleSticky);
  }

  popup = () => {
    window.postMessage("OPEN_FREE_RETURN_WINDOW", "*");
  };

  handleSticky = () => {
    const header = $("#header-content");
    const element = $("#sticky_element");
    const parent = $("#sticky_parent");
    const parentTop = parent.offset().top;
    const parentWidth = parent.width();
    const parentHeight = parent.height();
    const elementHeight = element.height();
    const headerHeight = header.height();
    const endStickyPosition = parentHeight - elementHeight;
    const stop = parentTop + parentHeight - headerHeight - elementHeight;
    const spaceWhite = 15;
    if (window.pageYOffset > parentTop - headerHeight - spaceWhite) {
      if (window.pageYOffset > stop - spaceWhite) {
        // stop
        element.css({
          position: "",
          top: "0",
          width: "auto",
          transform: `translateY(${endStickyPosition}px)`
        });
      } else {
        // sticky
        element.css({
          position: "fixed",
          top: headerHeight + spaceWhite,
          width: parentWidth,
          transform: ""
        });
      }
    } else {
      // back
      element.css({
        position: "",
        top: "0",
        width: "auto",
        transform: ""
      });
    }
  };

  componentDidUpdate(prevProps, prevStates) {
    $(".optionBoxes>.option-btn").on("click", function () {
      $(".optionBoxes>.option-btn").removeClass("select");
      $(this).addClass("select");
    });
    if (prevProps.product !== this.props.product) {
      const { recommendationVmTag, code, productName2, categories } =
        this.props.product;
      const { discountPrice, origPrice, media } = this.props.productBookingUnit;
      const vmTag = recommendationVmTag ? recommendationVmTag : "";
      // 將vmTag儲存在window,透過postMessage傳遞給ScarabQueue
      window.postMessage("SUBMIT_VMTAG", "*");
      window.ScarabQueue_vmTag = vmTag;
      this.setJSONLD();
      const _origPrice = origPrice || "HK$0";
      const _discountPrice = discountPrice || "HK$0";
      // Insider Event
      if (window.insider_object) {
        const product = {
          id: code,
          name: productName2,
          taxonomy: categories,
          currency: "HKD",
          unit_price: _origPrice.replaceAll("HK$", "").replaceAll(",", ""),
          unit_sale_price: _discountPrice
            .replaceAll("HK$", "")
            .replaceAll(",", ""),
          url: window.location.href,
          product_image_url: isArray(media.images)
            ? media.images[0].displayUrl
            : ""
        };
        window.insider_object.product = product;
      }
    }
  }

  setJSONLD = () => {
    const { product, productBookingUnit } = this.props;
    const jsonLdProductInfo = {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: `${product.productName1 ? product.productName1 : ""}${
        product.productName2 ? product.productName2 : ""
      }`,
      image:
        Array.isArray(productBookingUnit.media.images) &&
        productBookingUnit.media.images.length > 0
          ? productBookingUnit.media.images[0].displayUrl
          : "",
      description: product.productDesc,
      sku: product.code,
      brand: {
        "@type": "Brand",
        name: "EMPHASIS"
      },
      productID: product.code,
      offers: {
        price: productBookingUnit.discountPrice
          ? productBookingUnit.discountPrice
              .replace(/^HK\$/, "")
              .replace(/,/g, "")
          : "",
        priceCurrency: "HKD",
        availability:
          productBookingUnit.quantity - productBookingUnit.earmarkQuantity > 0
            ? "InStock"
            : "OutOfStock",
        url: window.location.href
      }
    };
    const script = document.createElement("script");
    script.setAttribute("type", "application/ld+json");
    script.textContent = JSON.stringify(jsonLdProductInfo);
    document.head.appendChild(script);
  };

  emailCanNotEmpty() {
    if (this.props.isEmailEmpty) {
      return (
        <div className="validate-error">
          <p style={{ color: "red", padding: "15px" }}>電郵地址不可為空。</p>
        </div>
      );
    } else {
      return null;
    }
  }
  emailContextIsFailed() {
    if (this.props.isEmailCheckFailed) {
      return (
        <div className="validate-error">
          <p style={{ color: "red", padding: "15px" }}>
            對不起!你所輸入的電郵地址不正確，請重新輸入。
          </p>
        </div>
      );
    } else {
      return null;
    }
  }
  proxyPrice(sellingPrice, fn) {
    return (sellingPrice && fn) || null;
  }
  getPo(cartItems, productId) {
    let count = 0;
    if (cartItems === undefined) return 0;
    if (productId === undefined) return 0;

    cartItems.forEach(function (item) {
      if (item.cbu === productId) {
        count++;
      }
    });
    return count;
  }

  openLiveChat = () => {
    if (window.LC_API) {
      window.LC_API.open_chat_window();
    }
  };

  handleReservation = () => {
    this.props.setToggleReservationPopup(true);
    // fixed background
    document.body.style.overflow = "hidden";
  };

  handleCollectionGA = () => {
    if (!window.dataLayer) return;
    const { code, usage, productName1, productName2 } = this.props.product;
    const { origPrice, discountPrice } = this.props;
    const params1 = {
      code,
      usage,
      productName1,
      productName2
    };
    const params2 = {
      origPrice,
      discountPrice
    };
    setGAEvent("click_PDP_collection_name", params1, params2);
  };

  render() {
    const {
      product,
      cartItems,
      productCbu,
      origPrice,
      currencyPrice,
      sellingPrice,
      quantity,
      earmarkQuantity,
      subOptionLv1DisplayList,
      subOptionLv2DisplayList,
      subOptionLv3DisplayList,
      returnable,
      productTag,
      discountPrice,
      productBookingUnit,
      ui,
      language
    } = this.props;
    const qtys = {
      stock: quantity - earmarkQuantity,
      purchase: this.getPo(cartItems, productCbu)
    };
    const ipCountry = getCookie("ipCountry");
    return (
      <div className="pdt_R_wrap sidebar_forSticky" id="sticky_parent">
        <div
          className="pdt_info_wrap sidebarInner_forSticky"
          id="sticky_element"
        >
          <div>
            <div className="tag d-block d-md-none">{productTag}</div>
            <div className="clearfix">
              <div className="tag float-right d-none d-md-block">
                {productTag}
              </div>
              <div className="float-left">
                {product.productName1 &&
                  (product.subCollectionLink ? (
                    <a
                      href={product.subCollectionLink}
                      className="collectionName color_style"
                      onClick={this.handleCollectionGA}
                    >
                      {product.productName1}
                    </a>
                  ) : (
                    <div className="collectionName">{product.productName1}</div>
                  ))}
                <div className="name">{product.productName2}</div>
              </div>
            </div>

            <div className="detailsSections_wrap">
              {/* saleType為normal/display-show-price/display-inventory才顯示價格區塊 */}
              {productBookingUnit.saleType &&
                ["normal", "display-show-price", "display-inventory"].includes(
                  productBookingUnit.saleType
                ) && (
                  <div className="detailsSection price_wrap">
                    <div
                      className="sellingPrice_wrap"
                      style={{ display: "flex" }}
                    >
                      {discountPrice && discountPrice !== origPrice ? (
                        <>
                          {/* 價錢有折扣 */}
                          <div className="product-orignal-price">
                            {origPrice}
                          </div>
                          <div>
                            <div className="price">
                              {(sellingPrice && sellingPrice) || discountPrice}
                            </div>
                            <div className="priceInEur">
                              {product.priceInEur}
                            </div>
                            {currencyPrice && (
                              <div
                                className="currencyPrice"
                                style={style.currencyPrice}
                              >
                                ({currencyPrice})
                              </div>
                            )}
                          </div>
                        </>
                      ) : (
                        <>
                          {/* 價錢沒折扣 */}
                          <div>
                            <div className="price">
                              {(sellingPrice && sellingPrice) || origPrice}
                            </div>
                            <div className="priceInEur">
                              {product.priceInEur}
                            </div>
                            {currencyPrice && (
                              <div
                                className="currencyPrice"
                                style={style.currencyPrice}
                              >
                                ({currencyPrice})
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}

              <div>
                {isArray(ui.t100Options) && <Matching />}
                {isArray(ui.t76Options) && <Sizes />}
                {isArray(ui.t78Options) && (
                  <Material options={ui.t78Options} useColorCode={true} />
                )}
                {isArray(ui.materialOptions) && (
                  <Material options={ui.materialOptions} useColorCode={false} />
                )}
              </div>

              <React.Fragment>
                {subOptionLv1DisplayList.subitems.length > 1 && (
                  <SubOptionLv1Section />
                )}
                {subOptionLv2DisplayList && <SubOptionLv2Section />}
                {subOptionLv3DisplayList && <SubOptionLv3Section />}
                {isArray(product.suggestions) && (
                  <Suggestions
                    suggestions={product.suggestions}
                    language={language}
                  />
                )}
              </React.Fragment>

              {/* saleType為display/display-show-price/display-inventory才顯示聯絡客服區塊  */}
              {productBookingUnit.saleType &&
                ["display", "display-show-price", "display-inventory"].includes(
                  productBookingUnit.saleType
                ) && (
                  <div>
                    <a
                      className="blockBtn addToCart_btn"
                      style={{ width: "100%", margin: "0px" }}
                      onClick={this.openLiveChat}
                    >
                      <Translation>
                        {t => <>{t("rightIndex.contact")}</>}
                      </Translation>
                    </a>
                    {/* 判斷地區符合才顯示預約到店按鈕 */}
                    {["CN", "HK", "MO", "ZZ"].includes(ipCountry) && (
                      <a
                        className="blockBtn addToCart_btn grey"
                        style={{
                          width: "100%",
                          margin: "0.5rem 0",
                          border: "1px solid #000",
                          color: "#000",
                          background: "#fff",
                          fontWeight: "bold"
                        }}
                        onClick={this.handleReservation}
                      >
                        <Translation>
                          {t => <>{t("rightIndex.reservation")}</>}
                        </Translation>
                      </a>
                    )}

                    <div className="helpContact_wrap">
                      <b>
                        <Translation>
                          {t => <>{t("rightIndex.needHelp")}</>}
                        </Translation>
                        ?
                      </b>
                      {"  +852 2192 3228"}
                    </div>
                  </div>
                )}

              {/* 數量目前先隱藏 */}
              {/* {pdt.isOutOfStock(
                qtys,
                <Quantity max={qtys.stock - qtys.purchase} />
              )} */}
            </div>

            {ui.display.sizeComment && (
              <div className="size-better-large-remark">
                {ui.display.sizeComment}
              </div>
            )}

            {productBookingUnit.announcementPriceTag && (
              <div
                className="announcement-price-tag-remark"
                dangerouslySetInnerHTML={{
                  __html: window.sanitizeHTML(
                    productBookingUnit.announcementPriceTag,
                  ),
                }}
              ></div>
            )}
            {productBookingUnit.priceTag && (
              <div
                className="price-tag-remark"
                dangerouslySetInnerHTML={{
                  __html: window.sanitizeHTML(productBookingUnit.priceTag),
                }}
              ></div>
            )}
            <div className="buttons_wrap">
              {/* {pdt.isOutOfStock(qtys, <FreeCustomize />)} */}
              {/* {shippingFeePromotionalMessage &&
                shippingFeePromotionalMessage !== null && (
                  <MessageV2
                    shippingFeePromotionalMessage={
                      shippingFeePromotionalMessage
                    }
                  />
                )} */}
              {productBookingUnit.saleType &&
              productBookingUnit.saleType === "normal" ? (
                <React.Fragment>
                  {(pdt.getSumQty(qtys) <= 0 && (
                    <>
                      {!["CN", "HK", "MO", "ZZ"].includes(ipCountry) && (
                        <Soldout />
                      )}
                    </>
                  )) ||
                    null}
                  <div className="addToBtns_wrap">
                    {pdt.isOutOfStock(
                      qtys,
                      <AddToCart
                        qtys={qtys}
                        isOutOfStock={pdt.getSumQty(qtys) <= 0}
                      />
                    )}
                    {/* 判斷地區符合才顯示預約到店按鈕 */}
                    {["CN", "HK", "MO", "ZZ"].includes(ipCountry) && (
                      <a
                        className={`blockBtn addToCart_btn ${
                          pdt.getSumQty(qtys) <= 0 ? "black_btn" : "white_btn"
                        }`}
                        style={{
                          width: "100%",
                          margin: "0.5rem 0",
                          color: pdt.getSumQty(qtys) <= 0 ? "#fff" : "#000"
                        }}
                        onClick={this.handleReservation}
                      >
                        <Translation>
                          {t => <>{t("rightIndex.reservation")}</>}
                        </Translation>
                      </a>
                    )}
                    {/* <AddToFav pdtId={productCbu} /> */}
                  </div>
                  {this.emailCanNotEmpty()}
                  {this.emailContextIsFailed()}
                  {/* <div className="checkStock_wrap">
                    <a href="/" className="checkStock_btn">
                      即時分店庫存查詢
                    </a>
                  </div> */}
                  <div className="helpContact_wrap">
                    <b>
                      <Translation>
                        {t => <>{t("rightIndex.needHelp")}</>}
                      </Translation>
                      ?
                    </b>
                    {"  +852 2192 3228"}
                  </div>
                </React.Fragment>
              ) : productBookingUnit.saleType &&
                productBookingUnit.saleType === "display" ? null : null}
            </div>

            <div className="services_wrap ">
              {(returnable && (
                <React.Fragment>
                  {productBookingUnit.saleType === "normal" ? (
                    <span className="service">
                      <img className="icon" src={product_icon_30day} alt="" />
                      <span onClick={this.popup} style={{ cursor: "pointer" }}>
                        <Translation>
                          {t => <>{t("rightIndex.returnExchange")}</>}
                        </Translation>
                      </span>
                    </span>
                  ) : null}
                </React.Fragment>
              )) ||
                null}

              <span className="service">
                <span>
                  <img className="icon" src={product_icon_1year} alt="" />
                  <span>
                    <Translation>
                      {t => <>{t("rightIndex.oneYear")}</>}
                    </Translation>
                  </span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    isEmailEmpty: state.validate.isEmailEmpty,
    isEmailCheckFailed: state.validate.isEmailCheckFailed,
    cartItems: state.cart.cartItems,
    origPrice: state.product.productBookingUnit.origPrice,
    discountPrice: state.product.productBookingUnit.discountPrice,
    currencyPrice: state.product.productBookingUnit.currencyPrice,
    sellingPrice: state.product.productBookingUnit.sellingPrice,
    quantity: state.product.productBookingUnit.quantity,
    earmarkQuantity: state.product.productBookingUnit.earmarkQuantity,
    subOptionLv1DisplayList: state.product.subOptionLv1DisplayList,
    subOptionLv2DisplayList: state.product.subOptionLv2DisplayList,
    subOptionLv3DisplayList: state.product.subOptionLv3DisplayList,
    returnable: state.product.productBookingUnit.returnable,
    productTag: state.product.product.productTag,
    shippingFeePromotionalMessage:
      state.product.ui.display.shippingFeePromotionalMessage,
    productBookingUnit: state.product.productBookingUnit,
    ui: state.product.ui
  };
};

const mapDispatchToProps = () => {
  return {
    setToggleReservationPopup: bool =>
      pickUpInStore.actions.setToggleReservationPopup(bool)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Right);
